

export default [
 
    {   // 物流预估时间管理
        path: "logistics/time",
        name: "timePrediction",
        component: () => import(/* webpackChunkName: "logistics" */"@/views/logistics/time/index"),
    },
    {   // 物流基础费用管理
        path: "logistics/cost",
        name: "costPrediction",
        component: () => import(/* webpackChunkName: "logistics" */"@/views/logistics/cost/index"),
    },
    {   // 进口商管理
        path: "logistics/importer",
        name: "importer",
        component: () => import(/* webpackChunkName: "logistics" */"@/views/logistics/importer/index"),
    }
  
]


